import { render, staticRenderFns } from "./MuscleMap.vue?vue&type=template&id=26ca8940"
import script from "./MuscleMap.vue?vue&type=script&lang=js"
export * from "./MuscleMap.vue?vue&type=script&lang=js"
import style0 from "./MuscleMap.vue?vue&type=style&index=0&id=26ca8940&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports